import SearchBarAutosuggest from './SearchBarAutosuggest';

export default SearchBarAutosuggest;
